import { useContext, useMemo } from 'react';
import { ProviderRole } from '@bariendo/lib/constants';
import { Practitioner } from '@medplum/fhirtypes';
import { ProviderDirectoryContext } from '@/contexts/contexts';
import { EMPTY_PROVIDER_DIRECTORY } from '@/services/provider-directory';

/**
 * The session's provider roster: role by practitioner id / name, plus the
 * Practitioner resources themselves. Empty outside ProviderDirectoryProvider.
 */
export function useProviderDirectory() {
  const context = useContext(ProviderDirectoryContext);
  const directory = context?.directory ?? EMPTY_PROVIDER_DIRECTORY;
  const practitioners = context?.practitioners ?? [];
  return { directory, practitioners, loading: context?.loading ?? false };
}

/** Roster members whose primary role is one of `roles` — the in-memory twin of a `PractitionerRole?role=` search. */
export function usePractitionersWithRoles(roles: readonly ProviderRole[]): Practitioner[] {
  const { directory, practitioners } = useProviderDirectory();
  return useMemo(
    () =>
      practitioners.filter((practitioner) => {
        const role = practitioner.id ? directory.roleByPractitionerId.get(practitioner.id) : undefined;
        return role !== undefined && roles.includes(role);
      }),
    [directory, practitioners, roles]
  );
}
